import React from 'react';
import styled from 'styled-components';
import { SPACING } from '@govuk-react/constants';
import {
    Main,
    GridRow,
    GridCol,
    LeadParagraph,
    Paragraph,
    InsetText,
    Header,
    Button
} from 'govuk-react';
import { ButtonArrow } from '@govuk-react/icons';

const Introduction = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const SpecialistTerm = styled('div')({
    paddingTop: SPACING.SCALE_2
});

const FormStart = styled('div')({
    paddingTop: SPACING.SCALE_2
});

const HomePage = () => (
    <Main>
        <GridRow>
            <GridCol columnTwoThirds>
                <Introduction>
                    <Header level={1}>Layout Homepage</Header>
                    <LeadParagraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam.
                    </LeadParagraph>
                    <Paragraph>
                        Excepteur sint occaecat **cupidatat** non proident, sunt in culpa
                        qui officia deserunt mollit anim id est laborum.
                    </Paragraph>
                    <InsetText>
                        <Paragraph mb={0}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                            eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </Paragraph>
                    </InsetText>
                </Introduction>
                <SpecialistTerm>
                    <Header level={4}>Content item</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum.
                    </Paragraph>
                </SpecialistTerm>
                <SpecialistTerm>
                    <Header level={4}>Content item</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum
                    </Paragraph>
                </SpecialistTerm>
                <FormStart>
                    <Button start icon={<ButtonArrow />}>
                        Let's start
                    </Button>
                </FormStart>
            </GridCol>
        </GridRow>
    </Main>
);

export default HomePage;
